import { get, post, url_domain, url_pre } from "@/plugins/api" // postJson

export function amountinfo(params) {
  return new Promise((resolve, reject) => {
      get(`${url_domain()}${url_pre()}/account/amount`, params)
          .then(res => {
              resolve(res.data)
          })
          .catch((error) => {
              reject(error)
          })
  })
}
export function amountlistinfo(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account/amount_list`, params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function coinPrice(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account/coin_price`, params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function amountlist(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account/amount/history?page=${params.page}&per_page=${params.per_page}&sortby=id&source=${params.source||''}&order=${params.order}&type=${params.type}&symbol=${params.symbol}`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function findUserInfo(params) {
    return new Promise((resolve, reject) => {
        post("/api/userInfo/findUserInfo", params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function findUnderFromUser(params) {
    return new Promise((resolve, reject) => {
        post("/api/userInfo/findUnderFromUser", params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function sendSMSCode(params) {
    return new Promise((resolve, reject) => {
        post("/api/smsAuthCode", params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function isRegistered(params) {
    return new Promise((resolve, reject) => {
        post("/api/userInfo/isRegistered", params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export default {
    amountinfo
}


